import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductsState } from "@insite/client-framework/Store/Data/Products/ProductsState";
import { Draft } from "immer";

const initialState: any = {
    warehouseData: {},
};

const reducer = {
    "Data/Products/CompleteLoadProductsSetWarehouse": (
        draft: Draft<ProductsState>,
        action: { parameter: object; collection: any },
    )  => {
        const { collection } = action;
        draft.dataViews = {... draft.dataViews, warehouseData: collection.properties}
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
